 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-de-js":"lang-de-js","lang-es-js":"lang-es-js"}[chunkId]||chunkId) + "." + {"chunk-004808c7":"dbd012d8","chunk-44f6bfe8":"86226f91","chunk-57b76aeb":"5e5dce8d","chunk-00f23376":"61fa0ce9","chunk-15283c76":"b9f2ed41","chunk-1b4f179e":"1e892b1f","chunk-0a657d2d":"dee4048f","chunk-ac41bc5c":"055a91e2","chunk-1e77c10f":"dd008f37","chunk-22eed1c8":"72559e33","chunk-2d0c1224":"4d1387c7","chunk-2d0c1966":"dae97c78","chunk-2d0db333":"dfe841ee","chunk-2fb95858":"13cee70a","chunk-30b40363":"87f2fffe","chunk-332bf524":"5f63043f","chunk-36672502":"c9f99372","chunk-36f4b83c":"e7a26e5d","chunk-385338b7":"4f2ef6c0","chunk-3f7df6c1":"19f02f72","chunk-410f9d69":"ad2a27c2","chunk-41963f82":"5693ce87","chunk-68209836":"148af643","chunk-730f9f18":"c99795cd","chunk-8d00f324":"b705fa19","chunk-94aa4c82":"1f1f237f","chunk-575e6190":"36aac64f","chunk-ffd75e48":"2eaed283","chunk-a1f0ef68":"1cbacb1e","chunk-21e142c4":"08ab62a8","chunk-c5001c3c":"4c9a6971","chunk-c6349a4e":"640f04b0","chunk-c678f76a":"b6b5fbcd","chunk-051e553c":"1e621391","chunk-34dd9124":"bb194c1e","chunk-3996c235":"ca66e0fb","chunk-6f605a98":"7e86bc11","chunk-78167758":"cf0930b6","chunk-805d6daa":"11b492f5","chunk-f5b27b10":"94d41f4f","lang-de-js":"28786160","lang-es-js":"d53202af"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-004808c7":1,"chunk-44f6bfe8":1,"chunk-57b76aeb":1,"chunk-00f23376":1,"chunk-15283c76":1,"chunk-1b4f179e":1,"chunk-0a657d2d":1,"chunk-ac41bc5c":1,"chunk-1e77c10f":1,"chunk-22eed1c8":1,"chunk-2fb95858":1,"chunk-30b40363":1,"chunk-332bf524":1,"chunk-36672502":1,"chunk-36f4b83c":1,"chunk-385338b7":1,"chunk-3f7df6c1":1,"chunk-410f9d69":1,"chunk-41963f82":1,"chunk-68209836":1,"chunk-730f9f18":1,"chunk-8d00f324":1,"chunk-94aa4c82":1,"chunk-575e6190":1,"chunk-ffd75e48":1,"chunk-a1f0ef68":1,"chunk-21e142c4":1,"chunk-c5001c3c":1,"chunk-c6349a4e":1,"chunk-c678f76a":1,"chunk-051e553c":1,"chunk-34dd9124":1,"chunk-3996c235":1,"chunk-6f605a98":1,"chunk-78167758":1,"chunk-805d6daa":1,"chunk-f5b27b10":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-de-js":"lang-de-js","lang-es-js":"lang-es-js"}[chunkId]||chunkId) + "." + {"chunk-004808c7":"19b688fd","chunk-44f6bfe8":"7626f9e6","chunk-57b76aeb":"224ab140","chunk-00f23376":"e9688988","chunk-15283c76":"b8f4fa6e","chunk-1b4f179e":"42ce6b18","chunk-0a657d2d":"299eba6a","chunk-ac41bc5c":"ca25a66e","chunk-1e77c10f":"31dacd03","chunk-22eed1c8":"54f572e1","chunk-2d0c1224":"31d6cfe0","chunk-2d0c1966":"31d6cfe0","chunk-2d0db333":"31d6cfe0","chunk-2fb95858":"f6760493","chunk-30b40363":"1c0aaddb","chunk-332bf524":"56a842b6","chunk-36672502":"ddc1d236","chunk-36f4b83c":"691a0782","chunk-385338b7":"ae6cfc16","chunk-3f7df6c1":"0e1d285c","chunk-410f9d69":"6b6f2321","chunk-41963f82":"b705a3e6","chunk-68209836":"9111193c","chunk-730f9f18":"c0cdddf2","chunk-8d00f324":"90192b67","chunk-94aa4c82":"ab79f4b9","chunk-575e6190":"8b140cc5","chunk-ffd75e48":"7e2a0de6","chunk-a1f0ef68":"224a4e4b","chunk-21e142c4":"4e579714","chunk-c5001c3c":"8a1c5393","chunk-c6349a4e":"2e3f35c8","chunk-c678f76a":"8b824525","chunk-051e553c":"76d1a31b","chunk-34dd9124":"a8243790","chunk-3996c235":"081740bd","chunk-6f605a98":"e673581b","chunk-78167758":"b85c7558","chunk-805d6daa":"ecfea73f","chunk-f5b27b10":"a653deb5","lang-de-js":"31d6cfe0","lang-es-js":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
